import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

const CURRENCY_SYMBOLS: Record<string, string> = {
  USD: "$",
  EUR: "€",
  GBP: "£",
  JPY: "¥",
  AUD: "A$",
  CAD: "C$",
  CHF: "CHF",
  CNY: "¥",
  INR: "₹",
  MXN: "$",
  BRL: "R$",
  ZAR: "R",
  AED: "د.إ",
  SAR: "﷼",
  EGP: "E£",
};

export function useCurrency() {
  const [currency, setCurrency] = useState<string>("USD");
  const [symbol, setSymbol] = useState<string>("$");

  useEffect(() => {
    fetchCurrency();

    // Subscribe to currency changes
    const channel = supabase
      .channel('currency-changes')
      .on(
        'postgres_changes',
        {
          event: 'UPDATE',
          schema: 'public',
          table: 'photographer_profiles'
        },
        (payload: any) => {
          if (payload.new.currency) {
            setCurrency(payload.new.currency);
            setSymbol(CURRENCY_SYMBOLS[payload.new.currency] || payload.new.currency);
          }
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, []);

  const fetchCurrency = async () => {
    const { data } = await supabase
      .from("photographer_profiles")
      .select("currency")
      .single();

    if (data?.currency) {
      setCurrency(data.currency);
      setSymbol(CURRENCY_SYMBOLS[data.currency] || data.currency);
    }
  };

  const formatPrice = (price: number) => {
    return `${symbol}${price.toLocaleString()}`;
  };

  return { currency, symbol, formatPrice };
}
